import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../services/api';

// ─────────────────────────────────────────────
// StationValjare
//
// Props:
//   allStationer : string[]   – alla tillgängliga stationer
//   value        : string[]   – aktuellt urval (kontrollerad)
//   onChange     : (string[]) => void  – anropas vid varje ändring
// ─────────────────────────────────────────────
const StationValjare = ({ allStationer, value, onChange }) => {
  const [selectedVO, setSelectedVO] = useState('');
  const [voStationer, setVoStationer] = useState([]); // [{ id, name, stationer: string[] }]

  // Hämta verksamhetsområden från API en gång
  useEffect(() => {
    fetchWithAuth('/api/verksamhetsomraden')
      .then(r => r.json())
      .then(setVoStationer)
      .catch(() => {});
  }, []);

  const handleVOChange = (vo) => {
    setSelectedVO(vo);
    if (vo) {
      const voData = voStationer.find(v => v.name === vo);
      if (voData) onChange(voData.stationer.filter(s => allStationer.includes(s)));
    }
  };

  const handleCheckbox = (s, checked) => {
    setSelectedVO('');
    onChange(checked ? [...value, s] : value.filter(x => x !== s));
  };

  return (
    <div>
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2 tw-flex-wrap">
        <span className="tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wide">
          Välj verksamhetsområde
        </span>
        <select
          value={selectedVO}
          onChange={e => handleVOChange(e.target.value)}
          className="tw-text-xs tw-border tw-border-gray-300 tw-rounded tw-px-2 tw-py-1 tw-bg-white tw-font-bold"
        >
          <option value="">—</option>
          {voStationer.map(vo => (
            <option key={vo.id} value={vo.name}>{vo.name}</option>
          ))}
        </select>
        <span className="tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wide">
          Välj stationer ({value.length} av {allStationer.length} valda)
        </span>
      </div>

      <div className="tw-bg-gray-50 tw-rounded-xl tw-border tw-border-gray-200 tw-p-3">
        <div className="tw-flex tw-gap-2 tw-mb-2">
          <button
            onClick={() => { setSelectedVO(''); onChange([...allStationer]); }}
            className="tw-text-xs tw-px-3 tw-py-1 tw-rounded tw-bg-blue-100 tw-text-blue-700 hover:tw-bg-blue-200"
          >
            Välj alla
          </button>
          <button
            onClick={() => { setSelectedVO(''); onChange([]); }}
            className="tw-text-xs tw-px-3 tw-py-1 tw-rounded tw-bg-gray-200 tw-text-gray-600 hover:tw-bg-gray-300"
          >
            Rensa
          </button>
        </div>
        <div className="tw-grid tw-grid-cols-3 md:tw-grid-cols-5 tw-gap-2 tw-max-h-44 tw-overflow-y-auto">
          {allStationer.map(s => (
            <label
              key={s}
              className={`tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 tw-py-1.5 tw-cursor-pointer tw-border tw-text-sm tw-transition-colors ${
                value.includes(s)
                  ? 'tw-bg-blue-50 tw-border-blue-300 tw-text-blue-800'
                  : 'tw-bg-white tw-border-gray-200 tw-text-gray-600'
              }`}
            >
              <input
                type="checkbox"
                checked={value.includes(s)}
                onChange={e => handleCheckbox(s, e.target.checked)}
                className="tw-w-3.5 tw-h-3.5"
              />
              <span className="tw-truncate">{s}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StationValjare;
